import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) {
      return;
    }
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", "/signin");
    api.post("/auth/google", { session_id: sessionId })
      .then(({ data }) => navigate("/signin", { replace: true, state: { challenge: data } }))
      .catch((e) => navigate("/signin", { replace: true, state: { error: formatApiError(e) } }));
  }, [location.hash, navigate]);

  return (
    <div className="grid min-h-screen place-items-center bg-oath-bg" data-testid="auth-callback">
      <Loader2 className="h-6 w-6 animate-spin text-oath-muted" />
    </div>
  );
}
